import { Injectable, Injector } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { AuthService } from '../../api/services/auth.service';
import 'rxjs/add/operator/do';
import 'rxjs/add/observable/of';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/debounceTime';

@Injectable()
export class ForbiddenInterceptor implements HttpInterceptor {

  private tokenCheck: Subject<any> = new Subject<any>();

  constructor(private injector: Injector) {
    this.tokenCheck.debounceTime(300).subscribe(() => this.checkToken());
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // needed because of this https://github.com/angular/angular/pull/19809 has not been merged yet
    const auth = this.injector.get(AuthService);
    return next.handle(request).do((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
      }
    }, (err: any) => {
      if (err instanceof HttpErrorResponse) {
        if (err.status === 403) {
          // auth.refreshPermissions().subscribe();
        } else if (err.status === 401) {
          this.tokenCheck.next(new Date().getTime());
        }
      }
    });
  }

  private checkToken() {
    const auth = this.injector.get(AuthService);
    auth.checkToken()
    .subscribe(
      console.log,
      () => auth.logout()
    );
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/interceptors/forbidden.interceptor.ts